//Built-In
import React, { Fragment } from 'react';

//External
import {
    Button,
    Input,
} from "reactstrap";
import cx from "classnames";
import { getSessionValue, getWABodyVariables, isMobile } from "../../Common/Appcommon";
import Select from "react-select";
import { Col, Row } from "react-bootstrap";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CratioFileUploader from "../Common/CratioFileUploader";
import CratioTooltip from "../../Common/CratioTooltip";
import { Controller } from "react-hook-form";
//Internal

export default class HeaderComponent extends React.Component {

    leadformname = getSessionValue('leadformname');

    constructor(props) {
        super(props);

    }

    handleInputChange = async (e) => {

    }

    render() {

        let { component, formDetail, formData, isNew, controller } = this.props;
        const { register, control, formState: { errors } } = this.props.useForm;
        let formInfo = formDetail[0];
        let fieldDetails = formDetail[1] !== undefined ? formDetail[1] : [];
        let format = component['format'];
        let others = component['text'] || ''; // RCS might have text even if format is not TEXT (e.g. for Title)
        let buttonLbl = "Choose JPG or PNG File";
        let documentFilters = ".jpg,.png,.jpeg";
        if (format == "DOCUMENT") {
            buttonLbl = "Choose PDF File";
            documentFilters = ".txt,.pdf,.csv,.docx,.html,.xlsx";
        } else if (format == "VIDEO") {
            buttonLbl = "Choose MP4 File";
            documentFilters = ".mp4,.3gp";
        } else if (format == "AUDIO") {
            buttonLbl = "Choose MP3 File";
            documentFilters = ".aac,.mp3,.mpeg,.amr";
        }
        let variables = others != "" ? getWABodyVariables(others) : []; // Extract variables from 'others' (which is the title text)
        let isCarouselCard = this.props.isCarousel && this.props.cardIndex !== undefined;
        let mediaPrefix = isCarouselCard ? `carousel_card_${this.props.cardIndex}_` : '';
        let mediaUrlKey = `${mediaPrefix}mediaUrl`;
        let mediaUrl = format != "TEXT" && formData != undefined ? formData[mediaUrlKey] : "";
        // CratioFileUploader always reads errors['mediaUrl'], so remap this card's error onto that key.
        let uploaderErrors = isCarouselCard
            ? { ...this.props.errors, mediaUrl: (this.props.errors || {})[mediaUrlKey] }
            : this.props.errors;
        // onFileUpload expects (event, cardIndex, 'carousel') to store media under the card's keys.
        let uploadHandler = isCarouselCard
            ? (event) => this.props.onFileUpload(event, this.props.cardIndex, 'carousel')
            : this.props.onFileUpload;
        let fileName = "";
        if (mediaUrl != "" && mediaUrl != undefined) {
            let mediaUrlArr = mediaUrl.split("/");
            fileName = mediaUrlArr[mediaUrlArr.length - 1];
        }
        let fieldsOptions = [];
        let skipFields = [
            `${this.leadformname}_id`,
            'Lead_ID',
            'wsapp_recent_activity',
            'wsapp_convo_status',
            'wsapp_unread_count',
            'wsapp_optin_status',
            'wsapp_recent_msg_id',
            'wsapp_enabled',
            'wsapp_blocked',
            'wsapp_opt',
            'wsapp_last_delivered',
            'wsapp_last_read',
            'wsapp_last_replied',
            'wsapp_last_sent_msg_id',
            'wsapp_last_sent_msg_id',
            'wsapp_completed_campaign'
        ];

        fieldsOptions.push({
            value: 'fallback', label: 'Use Fallback'
        });
        fieldDetails.map((field) => {
            let fieldName = field[2];
            let fieldLabel = field[3];
            let fieldType = field[4];
            let isConfigHide = parseInt(field[10]);
            let isViewHide = parseInt(field[11]);
            let formLabel = formInfo[2] || field[0];
            if (!isConfigHide && !isViewHide) {
                if (fieldType !== 'subtable' && fieldType !== 'reference_entityid' && fieldType !== "reference_group" && fieldType !== "entity_group" && fieldType !== "form_history") {
                    if (!skipFields.includes(fieldName)) {
                        fieldsOptions.push({
                            value: fieldName, label: formLabel.toUpperCase() + "::" + fieldLabel, fieldType: fieldType,
                        })
                    }
                }
            }
        });
        return (
            <Fragment>
                <label className={'group-header-lbl'} htmlFor="header_txt">Header</label>
                {
                    format === "TEXT" ?
                        (<div className={''}>
                            <input
                                type="text"
                                disabled={true}
                                name="header_txt"
                                id="header-txt"
                                value={others}
                                className={cx('form-control col-md-10', { '': variables.length > 0 })}
                            />
                        </div>) : (
                            <div className={cx({ 'hide': this.props.hideUpload })}>
                                <div className={'hide'} onChange={(event => { this.props.handleInputChange(event) })}>
                                    <input type="radio" value="upload" checked={formData['mediatype'] == undefined || formData['mediatype'] == 'upload'} name="mediatype" /> Upload
                                    <input type="radio" className={'ml-1'} value="url" checked={formData['mediatype'] == 'url'} name="mediatype" /> URL
                                </div>
                                <div className={cx('file_upload_container col-md-10 ', { 'show': formData['mediatype'] == 'upload' || formData['mediatype'] == undefined })}>
                                    <CratioFileUploader mediaUrl={formData[mediaUrlKey]} errors={uploaderErrors} btnLbl={buttonLbl} handleFile={uploadHandler} filesAccept={documentFilters} />
                                    <span className={`body-content-txt hide ${mediaUrl == '' ? 'hide' : ''}`}>Uploaded File: <a target="_blank" href={mediaUrl}>{mediaUrl}</a></span>
                                </div>
                                <div className={cx('mediaurl_container hide', { 'show': formData['mediatype'] == 'url' })}>
                                    <Input type="text" autoComplete={'off'} required={formData['mediatype'] == 'url'} value={formData[mediaUrlKey]} name={mediaUrlKey} onChange={(e) => (this.props.handleInputChange(e))} id={mediaUrlKey} />
                                </div>
                            </div>
                        )
                }
                <Row className={cx('mt-2 hide', { 'show': variables.length > 0 })}>
                    <Col md={'12'}>
                        {variables.map((variable) => {
                            let prefix = this.props.isCarousel && this.props.cardIndex !== undefined ? `carousel_card_${this.props.cardIndex}_` : '';
                            let selectId = prefix + `header_variable_${variable}`;
                            let defaultValueID = prefix + `header_df_value_field_${variable}`;

                            return (
                                <Row key={variable} className="mb-2">
                                    <Col md={'2'} className={cx('', { 'pr-0': !isMobile() })}>
                                        <input type={'text'} disabled={true} className={'form-control text-center'} value={`{{ ${variable} }}`} />
                                    </Col>
                                    <Col md={'4'} className={cx('', { 'variable-group': isMobile() })}>
                                        <Controller
                                            name={selectId}
                                            control={control}
                                            rules={{ required: variables.length > 0 && formData[selectId + "_selected"] === undefined ? "Message variable not selected" : false }}
                                            render={({ field }) => {
                                                return (
                                                    <Select
                                                        {...field}
                                                        id={selectId}
                                                        name={selectId}
                                                        value={formData[selectId + "_selected"]}
                                                        onChange={(e) => {
                                                            this.props.handleChange(e, selectId)
                                                            field.onChange(e);
                                                        }}
                                                        options={fieldsOptions}
                                                        className={`w-100 basic-multi-select ${errors[selectId] ? 'is-invalid' : ''}`}
                                                        classNamePrefix="wa-select"
                                                    />
                                                );
                                            }}
                                        />
                                        {errors[selectId] && <em className={`error invalid-feedback`}>{errors[selectId].message}</em>}
                                    </Col>
                                    <Col md={'4'} className={cx('', { 'variable-group': isMobile() })}>
                                        <div className={cx('d-flex align-items-center', { 'opacity-50': formData[selectId + "_selected"]?.value !== 'fallback' })}>
                                            <CratioTooltip title={"In case the dynamic value is empty for a particular customer, the fallback value will instead be sent."} content={<FontAwesomeIcon icon={faCircleInfo} />} />
                                            <input
                                                type={'text'}
                                                className={'form-control ml-1'}
                                                autoComplete={'off'}
                                                id={defaultValueID}
                                                name={defaultValueID}
                                                disabled={formData[selectId + "_selected"]?.value !== 'fallback'}
                                                required={formData[selectId + "_selected"]?.value === 'fallback'}
                                                value={formData[selectId + "_selected"]?.value === 'fallback' ? formData[defaultValueID] : ""}
                                                onChange={(e) => { this.props.handleInputChange(e) }}
                                                placeholder={'Fallback Value'}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            );
                        })}
                    </Col>
                </Row>
            </Fragment>
        )
    }
}
